// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2h2P9","row":"Node_row__3P8FX","label":"Node_label__P7jGa","footer":"Node_footer__CMtpt"};